export default __webpack_public_path__ + "static/media/sg.03c7ac8b.jpeg";